/**
 * Таблица соответствий русских и английских символов
 * по позиции клавиш на клавиатуре QWERTY/ЙЦУКЕН
 * 
 * Преобразует русские символы в английские по их позиции на клавиатуре
 * Пока не подключена к приложению - создана для будущего использования
 */

// Русские символы -> Английские символы (по позиции на клавиатуре)
export const ruToEnMap: Record<string, string> = {
    // Нижний регистр
    'й': 'q', 'ц': 'w', 'у': 'e', 'к': 'r', 'е': 't', 'н': 'y', 'г': 'u', 'ш': 'i', 'щ': 'o', 'з': 'p',
    'х': '[', 'ъ': ']',
    'ф': 'a', 'ы': 's', 'в': 'd', 'а': 'f', 'п': 'g', 'р': 'h', 'о': 'j', 'л': 'k', 'д': 'l',
    'ж': ';', 'э': "'",
    'я': 'z', 'ч': 'x', 'с': 'c', 'м': 'v', 'и': 'b', 'т': 'n', 'ь': 'm', 'б': ',', 'ю': '.',
    '.': '/',

    // Верхний регистр
    'Й': 'Q', 'Ц': 'W', 'У': 'E', 'К': 'R', 'Е': 'T', 'Н': 'Y', 'Г': 'U', 'Ш': 'I', 'Щ': 'O', 'З': 'P',
    'Х': '{', 'Ъ': '}',
    'Ф': 'A', 'Ы': 'S', 'В': 'D', 'А': 'F', 'П': 'G', 'Р': 'H', 'О': 'J', 'Л': 'K', 'Д': 'L',
    'Ж': ':', 'Э': '"',
    'Я': 'Z', 'Ч': 'X', 'С': 'C', 'М': 'V', 'И': 'B', 'Т': 'N', 'Ь': 'M', 'Б': '<', 'Ю': '>',
    ',': '?'
};

/**
 * Преобразует строку из русской раскладки в английскую
 * @param text - исходный текст на русской раскладке
 * @returns текст, преобразованный в английскую раскладку
 */
export function convertRuToEn(text: string): string {
    return text.split('').map(char => ruToEnMap[char] || char).join('');
}

/**
 * Проверяет, содержит ли строка русские символы
 * @param text - текст для проверки
 * @returns true если строка содержит русские символы
 */
export function containsRussian(text: string): boolean {
    return /[а-яё]/i.test(text);
}

/**
 * Автоматически преобразует текст из русской раскладки в английскую,
 * если в тексте присутствуют русские символы
 * @param text - исходный текст
 * @returns преобразованный текст (если был на русском) или исходный текст
 */
export function autoConvertToEnglish(text: string): string {
    if (containsRussian(text)) {
        return convertRuToEn(text);
    }
    return text;
}

export default {
    ruToEnMap,
    convertRuToEn,
    containsRussian,
    autoConvertToEnglish
};
